import React from 'react'
import PropTypes from 'prop-types'

import TimeFormatter from 'infra/TimeFormatter'

export default class JobsSummary extends React.PureComponent {

  static propTypes = {
    title: PropTypes.string.isRequired,
    values: PropTypes.array.isRequired
  }

  renderNameText(text, width) {
    return (
      <div
        key={text}
        style={{ display: 'flex', justifyContent: 'flex-end',
          flexShrink: 0, alignItems: 'center',
          paddingLeft: 16, paddingRight: 16, width: width }}>
        <span
          style={{ fontSize: 14 }}>
          {text}
        </span>
      </div>
    )
  }

  renderDays(values) {
    const views = []
    for (let i = 0; i < values.length; i++) {
      const time = values[i]
      views.push(
        <div
          key={i}
          style={{ display: 'flex', flexGrow: 0, flexShrink: 0,
            justifyContent: 'center', alignItems: 'center', width: '80px',
            borderRight: '1px solid #e4e7ea' }}>
          <span
            style={{ fontSize: 14, color: 'black' }}>
            { TimeFormatter.toHoursMinutesFormat(time) }
          </span>
        </div>
      )
    }
    return views
  }

  renderTotalText(totalTime) {
    return (
      <div
        key={'total'}
        style={{ display: 'flex', flexGrow: 1, minWidth: 64,
          alignItems: 'center', justifyContent: 'flex-end', paddingLeft: 16,
          paddingRight: 16 }}>
        <span
          style={{ fontSize: 14, color: 'black' }}>
          { TimeFormatter.toHoursMinutesFormat(totalTime) }
        </span>
      </div>
    )
  }

  render() {
    const total = this.props.values.length === 0
      ? 0 : this.props.values.reduce((a,b) => a+b)
    return (
      <div
        style={{ display: 'flex', flexDirection: 'row', height: '48px' }}>

        {this.renderNameText(this.props.title, 288)}

        <div
          style={{ display: 'flex', flexDirection: 'row', flexGrow: 1,
            border: '1px solid #e4e7ea', borderBottomWidth: 0, backgroundColor: '#fafbfc' }}>

          {this.renderDays(this.props.values)}
          {this.renderTotalText(total)}
        </div>
      </div>
    )
  }
  
}



// WEBPACK FOOTER //
// ./src/reports/timeAllocation/JobsSummary.js